import { Factory, trait } from 'miragejs';
import config from 'garaje/config/environment';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  rasterImageUrl: (i) => {
    if (config.environment === 'test') {
      return '/assets/images/features/avatar-placeholder.png';
    }

    if (i % 2) {
      return `https://picsum.photos/seed/${faker.lorem.word()}/1200/700`;
    } else {
      return `https://picsum.photos/seed/${faker.lorem.word()}/1200/900`;
    }
  },
  rasterImageName: () => `${faker.lorem.word()}.svg`,
  ordinality: (i) => i,
  name: () => faker.lorem.word(),

  afterCreate(mapFloor, server) {
    server.create('floor', { id: mapFloor.id, location: server.schema.locations.first() });
  },

  withFeatures: trait({
    afterCreate(mapFloor, server) {
      const room = server.schema.rooms.first() ?? server.create('room');
      const areaMap = server.schema.areaMaps.find(mapFloor.id) ?? null;

      server.createList('map-feature', 3, 'asDesk', { mapFloor, enabled: true });
      server.create('map-feature', 'asRoom', { mapFloor, areaMap, externalId: room.id, name: room.displayName });
      server.createList('map-feature', 4, 'asDeliveryArea', { mapFloor });
      server.createList('map-feature', 2, 'asVisitorArea', { mapFloor });
    },
  }),
});
